import { useAuth } from '@/lib'
import { useTranslation } from 'react-i18next'
import { YesNoScreen } from './yes-no-screen'

type Props = {
	onSubmit: (value: boolean) => void
	isSubmitting: boolean
}

export function ManagesTeamScreen(props: Props) {
	const { t } = useTranslation()
	const { user } = useAuth()
	return (
		<YesNoScreen
			title={t('onboarding.managesTeam.title')}
			subtitle={t('onboarding.managesTeam.subtitle')}
			current={user?.managesTeam ?? null}
			illustrationSrc="/onboarding/manages-team.png"
			{...props}
		/>
	)
}
